import type { OrderEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "orders";

const URLS = {
  create: BASE_URL,
  get: (orderId: OrderEntity.Schema["id"]) => [BASE_URL, orderId].join(SLASH),
  update: BASE_URL,
  updateServices: [BASE_URL, "services"].join(SLASH),
  delete: (orderId: OrderEntity.Schema["id"]) => [BASE_URL, orderId].join(SLASH),
  specifyPayment: [BASE_URL, "totalCost"].join(SLASH),
  getMany: [BASE_URL, "all"].join(SLASH),
  changeStatus: [BASE_URL, "status"].join(SLASH),
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
